import React, { useMemo, useCallback, useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import { getBuIdByName } from "../../utilities/apis/commonApis";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";

const DoughnutChart = ({ data, method, type, filters, setFilters }) => {
  const [offset, setOffset] = useState(0); // controls which "page" of 5 is shown

  // Reset offset when filters or data change
  useEffect(() => {
    setOffset(0);
  }, [data, filters]);


  const hasValidData = useMemo(() => {
    if (!data || data?.length === 0) return false;
    return data.some((item) => item._count && item._count.id > 0);
  }, [data]);

  // Build dataset with pagination + "Others"
  const result = useMemo(() => {
    if (!data || data?.length === 0) return [];

    const start = offset * 5;

    // reset if offset goes out of range
    if (start >= data?.length) {
      return data.slice(0, 5).concat(
        data?.length > 5
          ? [
              {
                _count: {
                  id: data.slice(5).reduce((s, i) => s + i._count.id, 0),
                },
                typeOfAgreement: "Others",
              },
            ]
          : []
      );
    }

    const top5 = data.slice(start, start + 5);
    const others = data.slice(start + 5);
    const othersCount = others?.reduce((sum, item) => sum + item._count.id, 0);

    return others?.length > 0
      ? [...top5, { _count: { id: othersCount }, typeOfAgreement: "Others" }]
      : top5;
  }, [data, offset]);

  // const handleChartClick = useCallback(
  //   async (event, elements, chart) => {
  //     if (!elements || elements.length === 0 || !hasValidData) return;

  //     const elementIndex = elements[0].index;
  //     const label = chart.data.labels[elementIndex].split("/")[0];

  //     if (label === "Others") {
  //       setOffset((prev) => {
  //         const next = prev + 1;
  //         return next * 5 >= data.length ? 0 : next; // cycle back
  //       });
  //       return;
  //     }

  //     if (type === "typeOfAgreement") {
  //       setFilters((prevFilters) =>
  //         prevFilters.typeOfAgreement === label
  //           ? prevFilters // no state update if unchanged
  //           : { ...prevFilters, typeOfAgreement: label }
  //       );
  //     } else if (type === "mapBusinessunit") {
  //       const response = await apiWrapWithErrorWithData(
  //         getBuIdByName({ buName: label })
  //       );
  //       setFilters((prevFilters) =>
  //         prevFilters.mapBusinessunit === response.result.id + ""
  //           ? prevFilters
  //           : { ...prevFilters, mapBusinessunit: response.result.id + "" }
  //       );
  //     }
  //   },
  //   [type, setFilters, hasValidData, data.length]
  // );
  const handleChartClick = useCallback(
    async (event, elements, chart) => {
      if (!hasValidData) return;

      // If clicked outside segments, reset filters
      if (!elements || elements?.length === 0) {
        setFilters((prev) => ({
          ...prev,
          typeOfAgreement: undefined,
          mapBusinessunit: undefined,
        }));
        return;
      }

      const elementIndex = elements[0].index;
      const label = chart.data.labels[elementIndex].split("/")[0];

      if (label === "Others") {
        setOffset((prev) => {
          const next = prev + 1;
          return next * 5 >= data?.length ? 0 : next;
        });
        return;
      }

      if (type === "typeOfAgreement") {
        setFilters((prevFilters) =>
          prevFilters.typeOfAgreement === label
            ? { ...prevFilters, typeOfAgreement: undefined } // unselect
            : { ...prevFilters, typeOfAgreement: label },
        );
      } else if (type === "mapBusinessunit") {
        const response = await apiWrapWithErrorWithData(
          getBuIdByName({ buName: label }),
        );
        setFilters((prevFilters) =>
          prevFilters.mapBusinessunit === response.result.id + ""
            ? { ...prevFilters, mapBusinessunit: undefined } // unselect
            : { ...prevFilters, mapBusinessunit: response.result.id + "" },
        );
      }
    },
    [type, setFilters, hasValidData, data?.length],
  );

  const chartOptions = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      onClick: handleChartClick,
      plugins: {
        legend: {
          position: "right",
          labels: {
            boxHeight: 10,
            boxWidth: 10,
          },
        },
      },
    }),
    [handleChartClick]
  );

  return (
    <>
      {hasValidData ? (
        <Doughnut data={method(result)} options={chartOptions} />
      ) : (
        <p style={{ textAlign: "center" }}>No data</p>
      )}
    </>
  );
};

export default DoughnutChart;
